import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, ButtonBase, InputBase, useTheme } from "@mui/material";
import cx from 'classnames';
import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MSelectWorkspaces from "../../../components/global/Modals/MSelectWorkspaces";
import Shbutton from "../../../components/theme/buttons/Shbutton";
import CardLabel from '../../../components/theme/label/CardLabel';
import TopRight from '../../../components/theme/positionals/TopRight';
import SelectGroup from "../../../components/theme/Select/SelectGroup";
import Subheading from "../../../components/theme/text/Subheading";
import Text from "../../../components/theme/text/Text";
import { useTopbar } from "../../../contexts/TopbarProvider";
import { setWorkSpace, updateMenuState } from '../../../newapi/global/settingsSlice';
import { useGetReturnsToProcessQuery, useGetReturnToProcessByIdMutation, useGetReturnToProcessBySearchStringMutation } from "../../../newapi/return/returnsSlice";
import { useFindWorkspacesSelectQuery } from "../../../newapi/warehouse/workspaceSlice";
import { tokens } from "../../../theme";
import ReturnsToProcessView from './views/ReturnsToProcessView';
import { general_states } from '../../../utils/staticEnums';
import Heading from '../../../components/theme/text/Heading';
import MpAddReturn from '../../../components/global/ModalsProgression/MpAddReturn/MpAddReturn';
import { ReactComponent as BarcodeSvg } from "../../../styles/svg/barcode.svg";
import MpCreateStandAloneReturn from '../../../components/global/ModalsProgression/MpCreateStandAloneReturn/MpCreateStandAloneReturn';

const ProcessInbound = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const dispatch = useDispatch();
    const [showReturnToProcess, setShowReturnToProcess] = useState(false);
    const [scannedValue, setScannedValue] = useState('none');
    const [highlightColor, setHighlightColor] = useState('none');
    const [incData, setIncData] = useState();
    const { showExtraComponent, clearExtraComponent,showExtraTitle,clearExtraTitle } = useTopbar();

    const [returnModalOpen, setReturnModalOpen] = useState(false);
    const returnModal = {
        open: returnModalOpen,
        setOpen: setReturnModalOpen
    }


    const [standAloneReturnModalOpen, setStandAloneReturnModalOpen] = useState(false);
    const standAloneReturnModal = {
        open: standAloneReturnModalOpen,
        setOpen: setStandAloneReturnModalOpen
    }

    const [orderData, setOrderData] = useState(null);

    const resetWorkspace = () => {
        dispatch(setWorkSpace({
            id: -1,
            name: "workspace_not_set"
        }))
    }

    const [open, setOpen] = useState(false);
    const workSpaceModal = {
        open: open,
        setOpen: setOpen
    }
    const [multipleOrders, setMultipleOrders] = useState(null);
    const [multipleOrdersToCreate, setMultipleOrdersToCreate] = useState(null);

    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const [searchString, setSearchString] = useState("");

    const handleReturnClose = () => {
        setOrderData(null);
        setMultipleOrdersToCreate(null);
        returnModal.setOpen(false);
        // refetchJobs();
    }

    const handleStandAloneReturnClose = () => {
        setOrderData(null);
        setMultipleOrdersToCreate(null);
        standAloneReturnModal.setOpen(false);
    }

    // const [getMyJob, {data: individualJob, isLoading: invididualJobLoading}] = useFindPickingJobMutation();
    const [getReturnById, {data: individualInbound, isLoading: invididualInboundLoading}] = useGetReturnToProcessByIdMutation();
    const [getReturnBySearchString, {data: individualBarcodeInbound, isLoading: invididualInboundBarcodeLoading}] = useGetReturnToProcessBySearchStringMutation();

    const [searchParams, setSearchParams] = useSearchParams();
    const hasHandledReturnParam = useRef(false);

    useEffect(() => {
        // Example: show different components based on user privileges
        if(selectedWorkSpace !== null && selectedWorkSpace.id > -1){
            showExtraComponent(
                <Box
                    className={cx('',{
                        'not-selected': selectedWorkSpace === null,
                        // 'not-selected': p,
                    })}
                    sx={{
                        height:40,
                        background:theme.palette.mode === "dark" ? colors.blue[800] : colors.primary[400],
                        borderRadius:5,
                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                        fontSize:14,
                        fontWeight:"bold",
                        fontFamily:"Roboto, sans-serif",
                        lineHeight:"40px",
                        px:2,
                        "&.not-selected" : {
                            background:colors.red[400],
                            animation: 'pulse 1.5s infinite',
                            '@keyframes pulse': {
                                '0%': {
                                    transform: 'scale(1)',
                                },
                                '50%': {
                                    transform: 'scale(1.2)',
                                },
                                '100%': {
                                    transform: 'scale(1)',
                                },
                            },
                        },
                        "@media screen and (max-width: 1024px)" : {
                            display:"none"
                        }
                    }}
                >
                    {selectedWorkSpace !== null ? selectedWorkSpace.name : t("no_selection")}
                </Box>
            );
        }
  
        return () => {
            clearExtraComponent();
        };
    }, [selectedWorkSpace]);

    useEffect(() => {
        showExtraTitle(t("process_returns"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    useEffect(() => {
        if(window.innerWidth > 1369){
            dispatch(updateMenuState(true));
        }
    },[])
    
    const handleGetPickingJobOrOrderToEcheck = async (e) => {
        if (e.key === 'Enter') {
            getReturnBySearchString(e.target.value)
            .unwrap()
            .then(result => {
                setScannedValue(e.target.value);
                if(result['responseType'] !== 'order'){
                    if(!result['multiple']){
                        setMultipleOrders(null);
                        setIncData(result);
                        setShowReturnToProcess(true);
                    } else {
                        setMultipleOrders(result['returns']);
                    }
                } else {
                    if(result['multiple']) {
                        setMultipleOrdersToCreate(result['orders']);
                    } else {
                        setOrderData({
                            id: result.id,
                            barcode: result.barcode,
                            deliveryName: result.deliveryName,
                            deliveryEmail: result.deliveryEmail,
                            relationId: result.relationId,
                            relation: result.relation,
                            trackandtrace: result.trackandtrace ?? ""
                        });
                        returnModal.setOpen(true);
                    }
                }
            })
            .catch(error => {
                setHighlightColor('red');
                toast.error(error.data?.message ??  `Scan een geldige krat of pickbon`, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
        }
    }

    const getReturnOnClick = async (id) => {
        if(invididualInboundLoading) return;
        
       await getReturnById(id).unwrap()
        .then(result => {
            if(result.returnlines.some(line => line.state === general_states.ACTIVE)){
                setIncData(result);
                setScannedValue("");
                setShowReturnToProcess(true);
                setMultipleOrders(null);
                setMultipleOrdersToCreate(null);
            } else {
                setHighlightColor("green");
                toast.success(t("return_processed"), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setShowReturnToProcess(false);
                setIncData(null);
                setMultipleOrders(null);
                setMultipleOrdersToCreate(null);
                getReturnBySearchString("");
            }
        })
        .catch(error => {
            setHighlightColor('red');
            toast.error(error.data?.message ??  `Scan een geldige krat of pickbon`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    useEffect(() => {
        if (highlightColor !== 'none') {
            setTimeout(() => setHighlightColor('none'), 500); // Duration to stay colored
        }
    }, [highlightColor]);

    useEffect(() => {
        const encoded = searchParams.get("r");
        if (encoded && !hasHandledReturnParam.current) {
            hasHandledReturnParam.current = true;
            try {
                const returnId = atob(encoded);
                if (returnId) {
                    setSearchParams({}, { replace: true });
                    getReturnOnClick(parseInt(returnId, 10));
                }
            } catch (e) {
                // invalid base64, ignore
            }
        }
    }, [searchParams]);

    // useEffect(() => {
    //     if(!showReturnToProcess) {
    //         refetchJobs();
    //     }
    // },[showReturnToProcess])


    const goBack = () => {
        setScannedValue(null);
        setShowReturnToProcess(false);
    }

    const getBackgroundColor = () => {
        switch (highlightColor) {
            case 'orange':
                return colors.orange[400];
            case 'green':
                return colors.green[400];
            case 'red':
                return colors.red[400];
            default:
                return 'initial'; // or your default color
        }
    };
    


    return (
        <Box 
            height={1} 
            display={"flex"} 
            width={1} 
            gap={4} 
            paddingX={4} 
            paddingTop={13} 
            overflow={"auto"}
            sx={{
                // overflow:"hidden",
                "@media screen and (max-width: 47.9375em)" : {
                    
                },
                background: getBackgroundColor(), // You can use your original color instead of 'initial' if needed
                transition: 'background-color 0.5s'
            }}
        >

            {/* List content body */}
            {!showReturnToProcess &&
                <Box
                    sx={{
                        flex:1,
                        display:"flex",
                        gap:4,
                    }}
                >
                    <Box
                        sx={{
                            minWidth:400,
                            overflow:"hidden",
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:'center',
                                pb:1,
                            }}
                        >
                            <Subheading>{t("to_process")}</Subheading>

                            {selectedWorkSpace.id !== -1 &&
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        gap:2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height:32,
                                            px:2,
                                            borderRadius:4,
                                            border:`1px solid ${colors.grey[100]}`,
                                            boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                            color: colors.txt["primary"],
                                            fontWeight:500,
                                            fontSize:14,
                                            fontFamily:"Roboto, sans-serif",
                                            lineHeight:'32px'
                                        }}
                                    >
                                        {selectedWorkSpace.name}

                                    </Box>

                                    {/* <ButtonBase
                                        onClick={refetchJobs}
                                        sx={{
                                            height:32,
                                            width:32,
                                            borderRadius:4,
                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                            display:"flex",
                                            alignItems:"center",
                                            justifyContent:"center"
                                        }}
                                    >
                                        <RefreshIcon/>

                                    </ButtonBase> */}
                                </Box>
                            }
                        </Box>
{/* 
                        <Box
                            sx={{
                                display:"flex",
                                gap:1.5,
                                mt:2,
                            }}
                        >
                            
                            <InputBase
                                sx={{
                                    height:32,
                                    width:1,
                                    borderRadius:4,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200],
                                    px:2,
                                }}
                            />
                        </Box> */}

                        {/* {selectedWorkSpace.id !== -1 &&
                            <Box
                                sx={{
                                    height:"calc(100% - 122px)",
                                    overflow:'auto',
                                    mt:3,
                                }}
                            >
                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        gap:1.5,
                                        mb:3,
                                    }}
                                >
                                    {jobsData?.map((item) => (
                                        <ButtonBase
                                            key={"item"+item.id}
                                            onClick={() => {
                                                getReturnOnClick(item.id);
                                                // getPickingJob(item.id);
                                            }}

                                            sx={{
                                                display:'flex',
                                                flexDirection:"column",
                                                alignItems:"flex-start",
                                                gap:2,
                                                boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                border:`1px solid ${colors.grey[100]}`,
                                                pt:2,
                                                pb:item.trackandtrace !== null ? 0 : 2,
                                                borderRadius:4,
                                                background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0],
                                                overflow:"hidden"
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display:'flex',
                                                    justifyContent:"space-between",
                                                    alignItems:"flex-start",
                                                    width:1,
                                                    px:2,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display:'flex',
                                                        flexDirection:"column",
                                                        gap:0.5,
                                                        // justifyContent:"space-between",

                                                    }}
                                                >
                                                    <Text black>
                                                        {item.reference} <Text light sx={{fontWeight:"normal",marginLeft:0.5,}} italic> ({item.order?.externalId})</Text>
                                                    </Text>
                                                    <Text>
                                                        {item.name}
                                                    </Text>
                                                    
                                                </Box>
                                                
                                                <TopRight>
                                                    <CardLabel
                                                        variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                                        position="child-tr"
                                                    >
                                                        {item.amountOfLines}
                                                    </CardLabel>
                                                </TopRight>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display:'flex',
                                                    gap:4,
                                                    pl:2,
                                                }}
                                            >
                                                 <Box
                                                    sx={{
                                                        display:'flex',
                                                        justifyContent:"flex-start",
                                                        flexDirection:"column"
                                                    }}
                                                >
                                                    <Text light>{item.relation?.name}</Text>

                                                </Box>
                                            </Box>
                                            
                                            {item.trackandtrace !== null &&
                                                <Box
                                                    sx={{
                                                        height:32,
                                                        width:1,
                                                        textAlign:"center",
                                                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                        lineHeight:"32px",
                                                    }}
                                                >
                                                    <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{item.trackandtrace }</Text>
                                                </Box>
                                            }
                                        </ButtonBase>
                                    ))}
                                </Box>
                            </Box>
                        } */}

                        {selectedWorkSpace.id === -1 &&
                            <SelectWorkSpace/>
                        }
                        {(multipleOrders !== null || multipleOrdersToCreate !== null) &&
                            <Box
                                sx={{
                                    height:"calc(100% - 122px)",
                                    overflow:'auto',
                                    mt:2,
                                    width:400,
                                }}
                            >
                                <Box
                                    sx={{
                                        mb:3,
                                        display:"flex",
                                        alignItems:'center',
                                        pl:0.5,
                                        pr:2,
                                        height:40,
                                        borderRadius:5,
                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height:32,
                                            background:theme.palette.mode === 'dark'  ? colors.grey[600] : colors.grey[100],
                                            borderRadius:4,
                                            px:2,
                                            mr:1.5,
                                            lineHeight:"32px",
                                        }}
                                    >
                                        <Text>{t("searched_value")}</Text>
                                    </Box>
                                    <Text
                                        noBreak
                                        bold
                                    >
                                        {scannedValue}
                                    </Text>
                                </Box>
                                {/* <Subheading sx={{flexShrink:0,}}>{scannedValue}</Subheading> */}
                                {(multipleOrders !== null && multipleOrders?.length > 0) &&
                                        <>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    gap:1,
                                                    alignItems:"center",
                                                }}
                                            >
                                                <Subheading>{t("found_returns_for")}</Subheading>
                                            </Box>

                                            <Box
                                                sx={{
                                                    mt:2,
                                                    display:"flex",
                                                    flexDirection:'column',
                                                    gap:1.5,
                                                    overflow:'auto'
                                                }}
                                            >

                                                {multipleOrders.map((item) => (
                                                
                                                    <ButtonBase
                                                        disabled={invididualInboundLoading}
                                                        key={"item"+item.id}
                                                        onClick={() => {
                                                            getReturnOnClick(item.id);
                                                            // getPickingJob(item.id);
                                                        }}

                                                        sx={{
                                                            display:'flex',
                                                            flexDirection:"column",
                                                            alignItems:"flex-start",
                                                            gap:2,
                                                            boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                            border:`1px solid ${colors.grey[100]}`,
                                                            pt:2,
                                                            pb:item.trackandtrace !== null ? 0 : 2,
                                                            borderRadius:4,
                                                            background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0],
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display:'flex',
                                                                justifyContent:"space-between",
                                                                alignItems:"flex-start",
                                                                width:1,
                                                                px:2,
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    flexDirection:"column",
                                                                    // justifyContent:"space-between",

                                                                }}
                                                            >
                                                                <Text black>
                                                                    {item.reference}
                                                                </Text>
                                                                <Text>
                                                                    {item.name}
                                                                </Text>
                                                                
                                                            </Box>
                                                            
                                                            <TopRight>
                                                                <CardLabel
                                                                    variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                                                    position="child-tr"
                                                                >
                                                                    {item.amountOfLines}
                                                                </CardLabel>
                                                            </TopRight>
                                                        </Box>

                                                        <Box
                                                            sx={{
                                                                display:'flex',
                                                                gap:4,
                                                                pl:2,
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    justifyContent:"flex-start",
                                                                    flexDirection:"column"
                                                                }}
                                                            >
                                                                <Text light>{item.relation?.name}</Text>

                                                            </Box>
                                                        </Box>
                                                        
                                                        {item.trackandtrace !== null &&
                                                            <Box
                                                                sx={{
                                                                    height:32,
                                                                    width:1,
                                                                    textAlign:"center",
                                                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                                                    lineHeight:"32px",
                                                                    borderBottomLeftRadius:'16px',
                                                                    borderBottomRightRadius:'16px',
                                                                }}
                                                            >
                                                                <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{item.trackandtrace }</Text>
                                                            </Box>
                                                        }
                                                    </ButtonBase>
                                                ))}
                                            </Box>
                                        </>

                                }
                                {multipleOrdersToCreate != null && 
                                    <>
                                        <Box
                                            sx={{
                                                mt: (multipleOrders !== null && multipleOrders?.length > 0) ? 3 : 0,
                                                display:"flex",
                                                gap:1,
                                                alignItems:"center",
                                            }}
                                        >
                                            <Subheading>{t("found_orders_for")}</Subheading>
                                        </Box>

                                        <Box
                                            sx={{
                                                mt:2,
                                                display:"flex",
                                                flexDirection:'column',
                                                gap:1.5,
                                                overflow:'auto'
                                            }}
                                        >
                                            {multipleOrdersToCreate.map((item,idx) => (

                                                <ButtonBase
                                                    key={"item"+item.id}
                                                    onClick={() => {

                                                        setOrderData({
                                                            id: item.id,
                                                            barcode: item.barcode,
                                                            deliveryName: item.deliveryName,
                                                            deliveryEmail: item.deliveryEmail,
                                                            relationId: item.relationId,
                                                            relation: item.relation
                                                        });
                                                        returnModal.setOpen(true);
                                                        setMultipleOrdersToCreate(null);
                                                        // getReturnOnClick(item.id);
                                                        // getPickingJob(item.id);
                                                    }}

                                                    sx={{
                                                        display:'flex',
                                                        flexDirection:"column",
                                                        alignItems:"flex-start",
                                                        gap:2,
                                                        boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                        border:`1px solid ${colors.grey[100]}`,
                                                        p:2,
                                                        borderRadius:4,
                                                        background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0],
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display:'flex',
                                                            flexDirection:"column",
                                                            // justifyContent:"space-between",

                                                        }}
                                                    >
                                                        <Text color={theme.palette.mode === "dark" ? "blue" : "primary"} black>
                                                            {item.deliveryName}
                                                        </Text>
                                                        <Text>
                                                            {item.barcode}
                                                        </Text>
                                                        
                                                    </Box>
                                                    <Box>
                                                        <Text light>{item.webshopreference}</Text>
                                                    </Box>
                                                </ButtonBase>
                                            ))}
                                        </Box>
                                    </>
                                }
                                {(multipleOrders?.length === 0) &&
                                    <Box
                                        sx={{
                                            p:2,
                                            background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                            border: `1px solid ${theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                            borderRadius:4,
                                        }}
                                    >
                                        <Subheading sx={{pb:1.5,}}>{t("no_returns_or_orders_found_title")}</Subheading>
                                        <Text>{t("no_returns_or_orders_found_description")}</Text>

                                        <ButtonBase
                                            onClick={() => {
                                                standAloneReturnModal.setOpen(true);
                                            }}
                                            sx={{
                                                mt:2,
                                                height:32,
                                                borderRadius:4,
                                                fontFamily:"Roboto, sans-serif",
                                                background:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                                fontWeight:500,
                                                fontSize:14,
                                                color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                                width:1,
                                                textAlign:"center",
                                            }}
                                        >
                                            {t("create_return_without_order")}
                                        </ButtonBase>
                                    </Box>
                                }
                            </Box>
                        }
                        {(multipleOrders === null && multipleOrdersToCreate === null) &&
                            <Box
                                sx={{
                                    height:"calc(100% - 122px)",
                                    overflow:'auto',
                                    mt:3,
                                }}
                            >
                                <Box
                                    sx={{
                                        p:3,
                                        background:colors.grey[50],
                                        border:`1px solid ${colors.grey[200]}`,
                                        borderRadius:4,
                                        display:'flex',
                                        flexDirection:'column',
                                        alignItems:'center'
                                    }}
                                >
                                    <Text>{t("search_on_the_right_and_items_appear_hear")}</Text>

                                </Box>
                            </Box>
                        }
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.bg["tertiary"],
                            borderTopRightRadius: 16,
                            borderTopLeftRadius: 16,
                            display:"flex",
                            alignItems:'center',
                            position:'relative',
                            overflow:"hidden",
                        }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.bg["tertiary"],
                                borderTopRightRadius: 16,
                                borderTopLeftRadius: 16,
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                paddingBottom: 3,
                                justifyContent: 'center',  // To center contents vertically
                                alignItems: 'center',      // To center contents horizontally
                                gap: 2 // Gap between items
                            }}
                        >
                            
                            <Box
                                sx={{
                                    height:210,
                                    width:440,
                                    borderRadius:5,
                                    position:"relative",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200],
                                    border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[300]}`,
                                    "& .echeck-barcode-svg" : {
                                        height:150,
                                        width:"380px !important",
                                        animation: 'pulsate 2s infinite',
                                        "& path" : {
                                            fill: theme.palette.mode === "dark" ? colors.txt["secondary"] : "#8E96A7"
                                        }
                                    }
                                }}
                            >
    
                                <BarcodeSvg 
                                    className="echeck-barcode-svg"
                                />
                            </Box>

                            <Box display="flex"
                                height="32px"
                                // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[200]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                                <InputBase 
                                    sx={{
                                        flex:1, 
                                        width:440,
                                        textAlign: 'center', 
                                        justifyContent: 'center',
                                        px:2,
                                    }} 
                                    placeholder={t("scan_trackinglink_or_search_name")}
                                    onKeyDown={handleGetPickingJobOrOrderToEcheck}
                                    autoFocus={true}
                                />
                            </Box>
                            
                            <Box>
                                <ButtonBase
                                    onClick={() => {
                                        standAloneReturnModal.setOpen(true);
                                    }}
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[400],
                                        color:theme.palette.mode === 'dark' ? colors.txt["primary"] : colors.txt["light"],
                                        height:32,
                                        borderRadius:4,
                                        px:2,
                                        width:440,
                                        fontFamily:"Roboto, sans-serif",
                                        fontWeight:500,
                                        fontSize:14,
                                    }}
                                >
                                    {t("create_return_without_order")}
                                </ButtonBase>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }

            {showReturnToProcess && 
                <ReturnsToProcessView
                    firstScannedBarcode={scannedValue}
                    setHighlightColor={setHighlightColor}
                    incData={incData}
                    // autoFinalize={autoFinalize}
                    // carrierMandatory={carrierMandatory}
                    selectedWorkSpace={selectedWorkSpace}
                    goBack={goBack}
                    setIncData={setIncData}
                    setShowReturnToProcess={setShowReturnToProcess}
                    // jobsLoading={jobsLoading}
                    // jobsFetching={jobsFetching}
                    // refetchJobs={refetchJobs}
                    getReturn={getReturnOnClick}
                />
                        
            }

            <MSelectWorkspaces
                open={workSpaceModal.open} 
                handleClose={() => workSpaceModal.setOpen(false)}
            />
            <MpAddReturn
                onOpen={() => returnModal.setOpen(true)} 
                onClose={() => returnModal.setOpen(false)} 
                open={returnModal.open} 
                handleClose={handleReturnClose} 
                data={orderData}
            />
            <MpCreateStandAloneReturn 
                onOpen={() => standAloneReturnModal.setOpen(true)} 
                onClose={() => standAloneReturnModal.setOpen(false)} 
                open={standAloneReturnModal.open} 
                handleClose={handleStandAloneReturnClose} 
                scannedValue={scannedValue}
            
            />
                 

        </Box>
    );
};

export default ProcessInbound;

const SelectWorkSpace = (props) => {
    const { t, ready } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const [selected, setSelected] = useState(-1);
    const [workTSpace,setTWorkSpace] = useState(selectedWorkSpace);

    const select = (selected) => {
        setTWorkSpace(data[selected]);
    }
    const { data: workSpaceData, isLoading } = useFindWorkspacesSelectQuery();

    useEffect(() => {
        if (!isLoading && workSpaceData) {
            const modifiedArray = workSpaceData.data.map(item => ({
                ...item,
                title: item.name
              }));
            
            setData(modifiedArray);
        }
    }, [workSpaceData, isLoading]);


    const selectWorkSpace = () => {
        dispatch(setWorkSpace({
            id:workTSpace.id,
            name:workTSpace.name,
        }));
    }

    useEffect(() => {
        if(data.length > 0) {
            for(var i = 0;i < data.length; i++) { 
                if(data[i].id === selectedWorkSpace.id){
                    setSelected(i);
                    // setSelected
                }
            }
        }
    }, [selectedWorkSpace,data]);


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return(
        <Box
            sx={{
                mt:3,
                py:3,
                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200],
                px:2,
                borderRadius:4,
            }}
        >
            
            <Box 
                sx={{
                    textAlign:"center",
                    // paddingY:4,
                    // paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{props.subheading || t("select_workspace")}</Subheading>
            </Box>
            <Box
                sx={{
                    pt:3,
                }}
            >
                <SelectGroup selected={selected} setSelected={select} options={data} />
            </Box>
            
            <Box
                sx={{
                    paddingTop:3,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton block className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} onClick={() => selectWorkSpace()} variant="contained">{t('select')}</Shbutton>
            </Box>
        </Box>
    )
}
